<template>
  <div>
    <InputFilter
      class="pt-10"
      :hideDetails="false"
      :hint="hint"
      :loading="loading"
    />

    <section class="filter-area">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" sm="10" class="mx-auto py-0">
            <v-row justify="space-between">
              <v-col cols="12" sm="6" class="success-select">
                <v-autocomplete
                  class="pt-0"
                  color="#1B5E20"
                  :items="categories"
                  item-text="name"
                  item-value="id"
                  :label="$t('label.categories')"
                  :loading="loading"
                  :disabled="loading"
                  clearable
                  v-model="filterInputs.category"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" class="error-select">
                <v-autocomplete
                  class="pt-0"
                  color="#B71C1C"
                  :items="subCategories"
                  item-text="name"
                  item-value="id"
                  :label="$t('label.subCategories')"
                  :loading="loading"
                  :disabled="loading"
                  clearable
                  v-model="filterInputs.sub_category"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </section>
  </div>
</template>

<script>
export default {
  name: "SCMItemsFilterComponent",
  components: {
    InputFilter: () => import("@/views/accounts/components/InputFilter")
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    categories: {
      type: Array,
      required: true
    },
    subCategories: {
      type: Array,
      required: true
    }
  },
  mounted() {
    Object.keys(this.filterInputs).forEach(key => {
      this.filterInputs[key] = this.$route.query[key] || "";
    });
    this.mappingQueryFiltersInputs = false;
  },
  data() {
    return {
      filterInputs: {
        category: "",
        sub_category: ""
      },
      mappingQueryFiltersInputs: true,
      hint: this.$t("search_hint")
    };
  },
  watch: {
    filterInputs: {
      handler(filtersVal) {
        if (this.mappingQueryFiltersInputs) {
          return;
        }

        this.$router.push({
          query: { ...this.$route.query, ...filtersVal, page: 1 }
        });
      },
      deep: true
    }
  }
};
</script>
